import React from "react";
import ReactGA from "react-ga";
import styled from "@emotion/styled";
import aboutA from "../../images/homepage/aboutA.jpg";
import aboutB from "../../images/homepage/aboutB.jpg";
import title from '../../images/homepage/story-title-w.png';

const Container = styled.div`
  width: 90%;
  max-width: 1180px;
  margin: auto;
`;

const Title = styled.h2`
  font-weight: bold;
  font-size: 48px;
  line-height: 71px;
  text-align: center;
  letter-spacing: 0.1rem;
  color: #30251D;
`;

const Line = styled.div`
  width: 40px;
  height: 2px;
  background-color: #30251D;
  margin: 60px auto;
  @media screen and (max-width: 767px) {
    margin: 40px auto;
  }
`;

const Box = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @media screen and (max-width: 767px) {
    justify-content: center;
  }
`;

const BoxItem = styled.a`
  width: 47.8%;
  position: relative;
  background-size: cover;
  background-position: center;
  &:hover {
    &::after {
      opacity: 0;
    }
    > h3 {
      opacity: 0;
    }
  }
  &:before {
    content: '';
    display: block;
    padding-bottom: 42.4778%;
  }
  &::after {
    transition: all .2s;
    content: '';
    width: 100%;
    height: 100%;
    background-color: rgba(48, 37, 29, 0.5);
    border: 1px solid #30251D;
    position: absolute;
    top: 0;
    left: 0;
  }
  &:first-child {
    background-image: url(${aboutA});
    @media screen and (max-width: 767px) {
      margin-bottom: 40px;
    }
  }
  &:last-child {
    background-image: url(${aboutB});
  }
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

const Deep = styled.h3`
  white-space: pre;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  color: #FFF;
  font-size: 72px;
  font-weight: 900;
  line-height: 1.1;
  letter-spacing: 0.1rem;
  transition: all .2s;
  img {
    width: 100%;
    max-width: 400px;
  }
  &::before {
    content: '深入了解';
    font-weight: 500;
    font-size: 36px;
    display: block;
    @media screen and (max-width: 767px) {
      font-size: 32px;
    }
  }
  @media screen and (max-width: 767px) {
    font-size: 52px;
  }
`;

const Anima = styled.h3`
  white-space: pre;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  font-weight: bold;
  font-size: 48px;
  line-height: 120%;
  letter-spacing: 0.1rem;
  color: #FFFFFF;
  transition: all .2s;
  @media screen and (max-width: 767px) {
    font-size: 32px;
  }
`;

const HomeAbout = () => {
  return (
    <Container>
      <Title>關於這次冒險</Title>
      <Line />
      <Box>
        <BoxItem href="https://www.toyota.com.tw/showroom/PRADO" target="_blank" rel="noreferrer" onClick={()=>{
              ReactGA.event({
                category: "202012_PRADO",
                action: "Click",
                label: `HomePageAbout-深入了解PRADO`,
              });
            }}>
          <Deep>
            <img src={title} alt=""/>
          </Deep>
        </BoxItem>
        <BoxItem href="http://www.wildonetaiwan.org/" target="_blank" rel="noreferrer" onClick={()=>{
              ReactGA.event({
                category: "202012_PRADO",
                action: "Click",
                label: `HomePageAbout-臺灣野灣野生動物保育協會`,
              });
            }}>
          <Anima>
            臺灣野灣野生
            <br />
            動物保育協會</Anima>
        </BoxItem>
      </Box>
    </Container>
  )
};

export default HomeAbout;